export const MIN_ORDER_VALUE_IN_USD = 100
